import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_puxke2dnj7: FaireBrandEntity = {
  token: "b_puxke2dnj7",
  type: "brand",
  name: "Apricot & Honey Gourmet",
  avatarUrl:
    "https://cdn.faire.com/fastly/8d0e5aafe8a45825fc26faff4309a8438b803fa33912d5b2d6144b1bf1d2d812.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/1a95861504ed7c98ad44ca5828adb247c20f28692caa729ec260743d45d3bb56.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8d0e5aafe8a45825fc26faff4309a8438b803fa33912d5b2d6144b1bf1d2d812.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1a95861504ed7c98ad44ca5828adb247c20f28692caa729ec260743d45d3bb56.jpeg",
  location: "BETHESDA, MD, USA",
  minimumOrderDollars: 139,
  rating: 4.3,
  reviewCount: 7,
  isInsider: true,
  description:
    "Apricot & Honey Gourmet, located in Maryland, is a family-operated importer and distributor of French artisanal fine Food.\n\nWe are continuously searching for the highest quality products to bring fully artisanal, unique food and beverage to the market.\n\nFrom premium virgin walnut oil made from handpicked walnuts to mustard, authentic honey, preserves or pure juice, we are proud to offer some of the best food products from France and bring the Gourmet taste to your table!",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:53.770Z",
    importedBy: "entity-db-cli",
  },
};
